import axios from "axios";

class ClientCompanyService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  /**
   * @author Lucia Alvarado
   * @description Get companys
   * @date 15-07-2022
   * @param {String} token
   * @param {Number} clientId
   * @returns {Object}
   * @memberof ClientCompanyService
   */
  async getClientCompany(clientId, token) {
    let response = await axios.get(
      `${this.apiUrl}/client-company?clientId=${clientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description Update client image profile
   * @date 27-07-2022
   * @param {String} token
   * @param {Object} clientCompanyData
   * @returns {Object}
   * @memberof ClientCompanyService
   */
  async updateClientCompanyLogo(token, clientCompanyLogo) {
    let response = await axios.put(
      `${this.apiUrl}/company-logo`,
      clientCompanyLogo,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description Create company
   * @date 27-07-2022
   * @param {String} token
   * @param {Object} clientCompanyData
   * @returns {Object}
   * @memberof ClientCompanyService
   */
  async createNewClientCompany(token, clientCompanyData) {
    let response = await axios.post(
      `${this.apiUrl}/client-company`,
      clientCompanyData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description Update client company
   * @date 27-07-2022
   * @param {String} token
   * @param {Object} clientCompanyData
   * @returns {Object}
   * @memberof ClientCompanyService
   */
  async updateClientCompany(token, clientCompanyData) {
    let response = await axios.put(
      `${this.apiUrl}/client-company`,
      clientCompanyData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description Update address company
   * @date 27-07-2022
   * @param {String} token
   * @param {Object} clientCompanyAddress
   * @returns {Object}
   * @memberof ClientCompanyService
   */
  async updateClientCompanyAddress(token, clientCompanyAddress) {
    let response = await axios.put(
      `${this.apiUrl}/client-company-address`,
      clientCompanyAddress,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description Update status company
   * @date 27-07-2022
   * @param {String} token
   * @param {Object} clientCompanyStatus
   * @returns {Object}
   * @memberof ClientCompanyService
   */
  async updateClientCompanyStatus(token, clientCompanyStatus) {
    let response = await axios.put(
      `${this.apiUrl}/client-company-status`,
      clientCompanyStatus,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description Create company certificate
   * @date 27-07-2022
   * @param {String} token
   * @param {Object} clientCompanyCertificate
   * @returns {Object}
   * @memberof ClientCompanyService
   */
  async createCompanyCertificate(token, clientCompanyCertificate) {
    let response = await axios.post(
      `${this.apiUrl}/company-certificate`,
      clientCompanyCertificate,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description Update company certificate
   * @date 27-07-2022
   * @param {String} token
   * @param {Object} clientCompanyCertificate
   * @returns {Object}
   * @memberof ClientCompanyService
   */
  async updateCompanyCertificateValidate(token, clientCompanyCertificate) {
    let response = await axios.post(
      `${this.apiUrl}/validated-company-certificate`,
      clientCompanyCertificate,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Lucia Alvarado
   * @description Update company certificate
   * @date 27-07-2022
   * @param {String} token
   * @param {Object} clientCompanyCertificate
   * @returns {Object}
   * @memberof ClientCompanyService
   */
  async updateCompanyCertificate(token, clientCompanyCertificate) {
    let response = await axios.put(
      `${this.apiUrl}/company-certificate`,
      clientCompanyCertificate,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Pedro Antonio
   * @description Get categories from a company
   * @date 05-07-2023
   * @param {String} token
   * @param {Object} companyId
   * @returns {Object}
   * @memberof ClientCompanyService
   */
  async getCategoriesByCompany(companyId, token) {
    let response = await axios.get(
      `${this.apiUrl}/categories?companyId=${companyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Pedro Antonio
   * @description Get categories from a company
   * @date 05-07-2023
   * @param {String} token
   * @param {Object} companyId
   * @param {Object} companyId
   * @returns {Object}
   * @memberof ClientCompanyService
   */
  async createCategoryCompany(companyId, categories, token) {
    let response = await axios.post(
      `${this.apiUrl}/assign-categories`,
      {
        companyId,
        categories
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }
}

export { ClientCompanyService as default };
